import React from 'react';
import LocalizedMessage from 'react-l10n';
import ReactLoading from 'react-loading';

class OrderListExportButton extends React.Component {

    state = {
        isLoading: false
    };

    handleClick = async () => {
        this.setState({ isLoading: true });

        try {
            await this.props.onClick();
        } finally {
            this.setState({ isLoading: false });
        }
    };

    render() {
        const { isLoading } = this.state;
        return (
            <button
                type='button'
                className='button button-filter'
                onClick={this.handleClick}
                disabled={isLoading}
                style={{ position: 'relative' }}
            >
                <span className='icon icon-save' />
                <span className='visible-xs-inline-block'
                    style={{
                        opacity:
                            isLoading === true
                                ? 0
                                : 1,
                    }}
                >
                    <LocalizedMessage id={'REPORTS_EXPORT_CSV'} />
                </span>
                <span className='hidden-xs'
                    style={{
                        opacity:
                            isLoading === true
                                ? 0
                                : 1,
                    }}
                >
                    <LocalizedMessage id={'REPORTS_EXPORT_CSV'} />
                </span>
                {
                    isLoading === true && (
                        <ReactLoading
                            className='button__spinner'
                            type='spin'
                            color='black'
                            height={20}
                            width={20}
                        />
                    )
                }
            </button >
        );
    }
}

// default props
OrderListExportButton.defaultProps = {};
// validate props
OrderListExportButton.propTypes = {};

export default OrderListExportButton;
